import script from "./KCropper.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCropper.vue?vue&type=script&setup=true&lang=ts"

import "./KCropper.vue?vue&type=style&index=0&id=52adc01c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52adc01c"]])

export default __exports__
import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
